import {
  AFFORDABILITY_TABLE_DATA_SUCCESS,
  AFFORDABILITY_TABLE_DATA_FAILURE,
  AFFORDABILITY_TABLE_DATA_LOADING,
} from '../../actions/actionTypes';

const initialState: any = {
  medSourcingTableData:[]
};

const affordabilityCommonReducer = (
  state = initialState,
  action: { type: string; payload?: any; key: string }
): any => {
  switch (action.type) {
    case AFFORDABILITY_TABLE_DATA_LOADING:
      return {
        ...state,
        [action?.key]: action.payload,
      };
    case AFFORDABILITY_TABLE_DATA_FAILURE:
      return {
        ...state,
        [action?.key]: action.payload,
      };
    case AFFORDABILITY_TABLE_DATA_SUCCESS:
      return {
        ...state,
        [action?.key]: action.payload,
      };

    default:
      return state;
  }
};

export default affordabilityCommonReducer;
